export enum FormattingTypes {
  MARK_BOLD = "bold",
  MARK_ITALIC = "italic",
  MARK_STRIKETHROUGH = "strikethrough",
  MARK_CODE = "code",
  ELEMENT_BACKLINK = "backlink",
  ELEMENT_LINK = "a",
  ELEMENT_SNIPPET = "snippet",
}
